import AddEditGameAssignmentModal from "./AddEditGameAssignmentModal";

export default AddEditGameAssignmentModal;